var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",null,{"data":_vm.data,"dataCopy":_vm.dataCopy})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }